// Chakra imports
import {
  Alert,
  AlertDescription,
  AlertDialog,
  AlertDialogContent,
  AlertDialogOverlay,
  AlertIcon,
  AlertTitle,
  CloseButton,
  Flex,
  useDisclosure,
} from "@chakra-ui/react";
import React, { useEffect } from "react";
// Custom components

export default function PopOverAlertSucess(props: {
  handleOpenAlertSucess?: any;
  isOpenSucess?: boolean;
  titleSucess?: string;
  subtitleSucess?: string;
  statusSucess?: any;
  [x: string]: any;
}) {
  const {
    handleOpenAlertSucess,
    isOpenSucess,
    titleSucess,
    subtitleSucess,
    statusSucess,
  } = props;
  const { onClose } = useDisclosure();
  const cancelRef = React.useRef();

  useEffect(() => {
    if (isOpenSucess)
      setTimeout(() => {
        handleOpenAlertSucess(false);
      }, 2000);
  }, [isOpenSucess, handleOpenAlertSucess]);

  return (
    <>
      <AlertDialog
        isOpen={isOpenSucess}
        motionPreset="slideInBottom"
        leastDestructiveRef={cancelRef}
        onClose={onClose}
        isCentered>
        <AlertDialogOverlay>
          <AlertDialogContent>
            <Alert
              borderRadius="5px"
              padding="30px"
              status={statusSucess}
              variant="solid">
              <Flex>
                <AlertIcon />
                <Flex direction="column">
                  <AlertTitle mr="12px">{titleSucess}</AlertTitle>
                  <AlertDescription>{subtitleSucess}</AlertDescription>
                </Flex>
              </Flex>
              <CloseButton
                position="absolute"
                right="8px"
                top="8px"
                onClick={() => handleOpenAlertSucess(false)}
              />
            </Alert>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>
    </>
  );
}
